import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { featuredServices, moreServices } from '../data/content';
import { useEstimate } from '../contexts/EstimateContext';
export function ServicesSection() {
  const {
    openEstimate
  } = useEstimate();
  return <section id="services" className="scroll-mt-20 bg-white py-20 md:py-24" data-id="element-293" data-mp="2gcpl15kgz5ss">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-294" data-mp="2l7lfecd6i592">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-295" data-mp="26k0g6tjfcq6f">
          <div data-id="element-296" data-mp="2bbs56zmxmnug">
            <h2 className="font-display text-3xl font-bold leading-tight text-forest md:text-5xl" data-id="element-297" data-mp="2bbihjipd0srx">What We Handle</h2>
            <p className="mt-4 text-lg text-ink-muted" data-id="element-298" data-mp="1xl53qzpsejuo">Hundreds of projects across North Dallas, homes and businesses.</p>
          </div>
          <button type="button" onClick={() => openEstimate()} className="group inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-brick" data-id="element-299" data-mp="22gkgtpfz0bq1">
            Get a free estimate
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-300" data-mp="2pm89z4snst8r" />
          </button>
        </div>

        <ul className="mt-10 grid gap-5 lg:grid-cols-2 lg:grid-rows-2" data-id="element-301" data-mp="2ymocaaxo1uc1">
          {featuredServices.map(({
          title,
          body,
          image,
          alt,
          icon: Icon
        }, i) => <li key={title} className={i === 0 ? 'lg:row-span-2' : ''} data-id="element-302" data-mp="26wjv0l57dnf1" data-mpi={i}>
              <button type="button" onClick={() => openEstimate(title)} aria-label={`Get an estimate for ${title}`} className={`group relative block h-full w-full overflow-hidden rounded-2xl bg-forest-dark text-left ${i === 0 ? 'min-h-[420px] lg:min-h-[600px]' : 'min-h-[280px]'}`} data-id="element-303" data-mp="26up9b4m3xr9w">
                <img src={image} alt={alt} className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-304" data-mp="1n6pu9hkifxyo" />
                <div className="absolute inset-x-3 bottom-3 rounded-xl bg-white/95 p-5 backdrop-blur md:inset-x-4 md:bottom-4" data-id="element-305" data-mp="3najzyy5hxph2">
                  <div className="flex items-start justify-between gap-4" data-id="element-306" data-mp="3s33d5u09uilc">
                    <div data-id="element-307" data-mp="vqvldvh834w">
                      <h3 className="flex items-center gap-2 text-lg font-semibold text-forest md:text-xl" data-id="element-308" data-mp="uxy73ieqpzf">
                        <Icon className="h-5 w-5 text-leaf" aria-hidden="true" data-id="element-309" data-mp="2zextlakyezn3" />
                        {title}
                      </h3>
                      <p className="mt-1 text-sm leading-relaxed text-ink-muted" data-id="element-310" data-mp="39bkd9w1jnknj">{body}</p>
                    </div>
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-forest text-white transition-colors duration-150 group-hover:bg-brick" data-id="element-311" data-mp="3eax0wj08ovr6">
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-312" data-mp="tk4tzuqh91gz" />
                    </span>
                  </div>
                </div>
              </button>
            </li>)}
        </ul>

        <ul className="mt-14 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-313" data-mp="293clr5ox0jt6">
          {moreServices.map(({
          label,
          body,
          icon: Icon
        }) => <li key={label} className="flex gap-4 border-t border-stone-line pt-6" data-id="element-314" data-mp="24at705ehrims">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-leaf/10 text-forest" data-id="element-315" data-mp="1zchvlq8jt02g">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-316" data-mp="1ufj5rjvx3fa2" />
              </span>
              <div data-id="element-317" data-mp="1qbteunrrsllv">
                <h3 className="font-semibold text-ink" data-id="element-318" data-mp="1qepgam2ttsf2">{label}</h3>
                <p className="mt-1 text-sm leading-relaxed text-ink-muted" data-id="element-319" data-mp="1lel0yzdnn3qf">{body}</p>
              </div>
            </li>)}
        </ul>
        <p className="mt-10 text-ink-muted" data-id="element-320" data-mp="1ggrs1ykyvvmg">…and more. If it’s outdoors, ask us.</p>
      </div>
    </section>;
}